let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1LyfS")).then(() => parcelRequire('8uYLy'));